module.exports = __webpack_public_path__ + "3a14b2ac534835338b2f1a31bdc32a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-320.jpg
// module id = 507
// module chunks = 0